/** Shift ids assigned to a person. An empty shiftIds list must not hide shiftId. */
export function employeeShiftIds(employee) {
  const ids = Array.isArray(employee?.shiftIds) ? employee.shiftIds.filter(Boolean) : []
  if (ids.length) return ids
  return employee?.shiftId ? [employee.shiftId] : []
}

function shiftCoversDay(shift, day) {
  const days = Array.isArray(shift?.daysOfWeek) ? shift.daysOfWeek : []
  if (!days.length) return shift?.isFlexible === true
  return days.includes(day)
}

/** The shift assigned to this person on this weekday, including flexible shifts. */
export function assignedShiftForDate(employee, date, shifts = []) {
  const ids = new Set(employeeShiftIds(employee))
  if (!ids.size || !(date instanceof Date) || Number.isNaN(date.getTime())) return null
  const day = date.getDay()
  return (shifts || []).find((shift) =>
    ids.has(shift.id)
    && shift.isActive !== false
    && shiftCoversDay(shift, day)
  ) || null
}
